import {DATATABLE_RESET_SEARCH} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import unsetParam from '~/frontend/src/actions/panel/common/unsetParam';
import {
    clearElusiveData,
    setElusiveData as setElusiveDataOrig,
    SetElusiveDataAction
} from '~/frontend/src/actions/elusiveData';
import {PanelElusiveData} from '~/frontend/src/components/base/DataTable';


type SetElusiveData = ( panelKey : string, data : PanelElusiveData ) => SetElusiveDataAction;


const setElusiveData = setElusiveDataOrig as SetElusiveData;


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {Function}
 */
const resetSearch = ( panelKey : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    const elusiveData  = getState().elusiveData?.[ panelKey ],
          columnsCache = elusiveData?.columnsCache;

    dispatch( {
        type: DATATABLE_RESET_SEARCH,
        panelKey
    } );

    dispatch( unsetParam( panelKey, 'page' ) );

    dispatch( clearElusiveData( panelKey ) );

    if ( columnsCache ) {
        for ( const field of Object.keys( columnsCache ) ) {
            columnsCache[ field ].cellCache = {};
        }

        dispatch( setElusiveData( panelKey, { columnsCache } ) );
    }
}
export type ResetSearch = typeof resetSearch;

export default resetSearch;
